import FormaDetail from './Detail';

export default FormaDetail;
